module.exports = __webpack_public_path__ + "static/media/fb.c509a4c4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fb.svg
// module id = 111
// module chunks = 0